var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"md":"12","lg":"6"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('stock')))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }